<div class="border-bottom mb-2 mt-3">
  <ng-content select=".title"></ng-content>
</div>
@if (devices?.length > 0) {
<div class="row g-0 my-1">
  @for (device of devices; track device) {
  <div class="col-12 col-lg-6">
    <era-device-grid-item [device]="device"
                          (click)="select(device)"></era-device-grid-item>
  </div>
  }
</div>
} @else {
<ng-content select=".empty"></ng-content>
}